<template>
  <div class="overflow-hidden modal">
    <!-- overlay -->
    <transition
      name="overlay"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >

      <portal to="overlay">
        <div class="fixed pin z-20" v-if="isModalVisible">
          <div
            @click="hideModal()"
            class="absolute pin bg-black opacity-25"></div>
        </div>
      </portal>
    </transition>
    <!-- end overlay -->

    <transition
      name="paths"
      leave-active-class="animated fadeOut faster"
      enter-active-class="animated fadeIn faster"
    >

      <portal to="modal">
        <div v-if="isModalVisible"
          class="fixed pin flex modal overflow-auto z-40">
          <div
            class="relative bg-gray-lightest w-full flex-col flex overflow-auto p-8">

            <div class="container mx-auto">
              <div class="lg:w-1/2 m-auto">

                <div @click="goBack()"
                  class="text-xs cursor-pointer underline text-full-blue"
                >Back</div>

                <div class="flex justify-between items-center pb-6">
                  <h2 class="text-2xl py-4 font-bold">Change Folder <a target="_blank" href="https://www.tatatap.com/organize" class="text-xs font-normal">About</a></h2>
                </div>

                <div class="container">
                  <div class="pb-8">
                    <folder-select :path="folder" @select="handleFolderNav" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </transition>
  </div>
</template>

<script>
 import path from 'path';
 import FolderSelect from '@/components/FolderSelect';

 export default {
   name: 'folder-modal',

   props: {
     folder: {
       type: String
     },
     isModalVisible: {
       type: Boolean,
       default: true
     }
   },

   components: {
     FolderSelect
   },

   methods: {
     handleFolderNav (folder) {
       this.$emit('select', folder);
     },

     hideModal () {
       this.$emit('close');
     },
     goBack() {
       this.hideModal()
     }
   },
 }
</script>
